import * as React from "react";
import { forwardRef } from "react";
const SvgSsPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 8 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.399414, y: 0.199707, width: 2.39966, height: 9.6, rx: 1.19983, fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 5.19922, y: 0.199707, width: 2.39966, height: 9.6, rx: 1.19983, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSsPause);
export { ForwardRef as ReactComponent };
